import { createTheme } from '@mui/material/styles';

const lideaGreen = '#43a117';
const lideaSurface = '#97c416';
const lideaDark = '#33434b';
const rowSelectedBg = '#f0f7e8';
const rowSelectedHoverBg = '#e6f0dc';
const rowHoverBg = '#f4f6f8';
const rowZebraBg = '#fafbfc';

/** MUI theme for Table and other @mui/material components (inside MantineProvider). */
export const lideaMuiTheme = createTheme({
  palette: {
    primary: {
      main: lideaGreen,
    },
    action: {
      selected: rowSelectedBg,
      // MUI TableRow uses alpha(color, selectedOpacity + hoverOpacity) on selected:hover.
      // Values must stay in [0, 1]; row colors are overridden in MuiTableRow below.
      selectedOpacity: 0.08,
      hover: rowHoverBg,
      hoverOpacity: 0.04,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #e9ecef',
          borderRadius: 8,
          backgroundColor: '#fff',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: rowZebraBg,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          fontSize: '0.875rem',
          color: lideaDark,
          borderBottom: '2px solid #e9ecef',
          backgroundColor: rowZebraBg,
        },
        body: {
          fontSize: '0.875rem',
          color: lideaDark,
          borderBottom: '1px solid #eef0f2',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.12s ease',
          '&.Mui-selected': {
            backgroundColor: `${rowSelectedBg} !important`,
            boxShadow: `inset 3px 0 0 ${lideaSurface}`,
          },
          '&.Mui-selected:hover': {
            backgroundColor: `${rowSelectedHoverBg} !important`,
          },
          '&:hover': {
            backgroundColor: rowHoverBg,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#ced4da',
          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: lideaGreen,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#6c757d',
          '&:hover': {
            color: lideaGreen,
            backgroundColor: 'rgba(67, 161, 23, 0.08)',
          },
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: lideaDark,
          '&:hover': {
            color: lideaGreen,
          },
          '&.Mui-active': {
            color: lideaGreen,
          },
        },
        icon: {
          color: `${lideaGreen} !important`,
        },
      },
    },
  },
});

export default lideaMuiTheme;
